import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useProductionCenterPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canCreate, canUpdate, canDuplicate, canDelete } = useMemo(
    () => ({
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_PRODUCTION_CENTER]),
      canUpdate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_PRODUCTION_CENTER]),
      canDuplicate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_PRODUCTION_CENTER]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_PRODUCTION_CENTER]),
    }),
    [hasPlatformPermission]
  );

  return {
    canCreate,
    canUpdate,
    canDuplicate,
    canDelete,
  };
};
